import { useState } from 'react'

import dayjs from 'dayjs'

import { Button } from '@tribeplatform/react-ui-kit/Button'
import {
  DateTimePicker,
  DateValue,
} from '@tribeplatform/react-ui-kit/DateTimePicker'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { T } from '../../i18n/components/T.js'

interface Props {
  open: boolean
  value?: DateValue
  loading?: boolean
  setOpen: (open: boolean) => void
  onSubmit: (date: DateValue) => unknown
}

export const SchedulePostPopup = ({
  open,
  value,
  setOpen,
  onSubmit,
  loading,
}: Props) => {
  const now = new Date()
  const currentValue = value ? new Date(value) : now
  const tenMinutesFromNow = new Date(currentValue.getTime() + 10 * 60 * 1000)
  const [selectedDate, setSelectedDate] = useState<DateValue>(
    value ?? tenMinutesFromNow,
  )
  const disableSubmit =
    !selectedDate || loading || dayjs(selectedDate).isSame(value)

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Modal.Header
        title={
          value ? (
            <T defaultMessage="Reschedule" id="Generics.Reschedule" />
          ) : (
            <T defaultMessage="Schedule" id="Generics.Schedule" />
          )
        }
        description={
          <T
            id="Post.ScheduleDescription"
            defaultMessage="Schedule the post to be published at a specific time."
          />
        }
      />
      <Modal.Content>
        <DateTimePicker
          minDate={new Date()}
          value={selectedDate}
          onChange={value => setSelectedDate(value)}
          placeholder={new Date().toLocaleDateString()}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button
          variant="primary"
          onClick={() => onSubmit(new Date(selectedDate).toISOString())}
          loading={loading}
          disabled={disableSubmit}
        >
          {value ? (
            <T defaultMessage="Reschedule" id="Generics.Reschedule" />
          ) : (
            <T defaultMessage="Schedule" id="Generics.Schedule" />
          )}
        </Button>
        <Button variant="secondaryNeutral" onClick={() => setOpen(false)}>
          <T defaultMessage="Cancel" id="Generics.Cancel" />
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
